export const SET_PRINTING_DATA = 'SET_PRINTING_DATA' as const;
export const CLEAR_PRINTING_DATA = 'CLEAR_PRINTING_DATA' as const;

type SetPrintingDataAction = {
  type: typeof SET_PRINTING_DATA;
  payload: {
    docUrl: string;
    docName: string;
  };
};

type ClearPrintingDataAction = {
  type: typeof CLEAR_PRINTING_DATA;
};

export const setPrintingData = ({
  docUrl,
  docName,
}: {
  docUrl: string;
  docName?: string;
}): SetPrintingDataAction => ({
  type: SET_PRINTING_DATA,
  payload: {
    docUrl,
    docName: docName || docUrl.split('/').pop() || '',
  },
});

export type PrintingAction = SetPrintingDataAction | ClearPrintingDataAction;
